import { MyFirebaseObject } from './my-firebase-object';
import { MyFirebaseList } from './my-firebase-list';
import { Observable } from 'rxjs/Observable';
import { Observer } from "rxjs/Observer";
import 'rxjs/add/operator/map';

import { Injectable, NgZone } from '@angular/core';
import firebase from 'firebase';

/*
  Manage Firebase 

  getO, getP
  getObject, getList

  Attention toute special aux update/change detection Angular, via NgZone.run

  TODO:
    list etendre filtre, start-nb, order by
    changer orders par orderBy de firebase

*/
@Injectable()
export class MyFirebase {

  constructor(private ngZone: NgZone) {
    // console.log('Hello MyFirebase');
  }


  // Build and get a MyFirebaseList
  getList(refEles : firebase.database.Reference, refChildren:firebase.database.Reference) {
    return new MyFirebaseList(this, refEles, refChildren);
  }


  // Build and get a MyFirebaseObject
  getObject(refObject : firebase.database.Reference) {
    return new MyFirebaseObject(this, refObject);
  }


  //
  // Angular ChangeDetection Observable and Promise
/*
  CHD 13 06 2017

  Angular ChangeDetection Observable and Promise

  1)  getO et getP return Observable/Promise executer dans Zone, currentZone
    ==> faire le getO getP dans la zone, ! pas dans service sans zone...


  2) faire executer tous les event Firebase dans la zone current ?
    ==> comment avoir cette zone courante
    ==> risque de beaucoup d'update

https://angular.io/docs/ts/latest/api/core/index/NgZone-class.html

https://blog.thoughtram.io/angular/2016/02/01/zones-in-angular-2.html
https://github.com/angular/zone.js/

https://github.com/angular/angularfire2/blob/master/src/database/firebase_object_factory.ts


*/


  // Update Angular, tick, for Observable, Promise in Angular
  public zoneScheduler : (o: any)=>any;

  // for Observable, Promise in Angular
  private zsc( op ) : any {

    if (this.zoneScheduler) 
      return this.zoneScheduler(op);
    return op;
  }



// /**
//  * TODO: remove this scheduler once Rx has a more robust story for working
//  * with zones.
//  */
// export class ZoneScheduler {
//   constructor(public zone: Zone) {}

//   schedule(...args): Subscription {
//     return <Subscription>this.zone.run(() => queue.schedule.apply(queue, args));
//   }
// }


  public runInZone( fct ) {

    if (!this.ngZone) {
      return fct();
    }

    return this.ngZone.run( ()=> { return fct(); } );
  }



  //
  // Get T for ref , Return Observable<T>
  getO<T>(ref : firebase.database.Reference): Observable<T>  {

    let objectObservable = new Observable<T>( (obs: Observer<T>) => {         
      try {
        let fn = ref.on('value', (snapshot) => { 

          return this.runInZone( ()=> { 
            let val : T = snapshot.val() as T;          
            obs.next(val);
          });          

        }, (err) => {  

// Error
console.error("MyFirebase.getO Error: " + err);
          return this.runInZone( ()=> { 
            obs.error(err);  
            obs.complete();  
          });
          
        });
        return () => {
          ref.off('value', fn);
        }

      } catch(err) { 
        return this.runInZone( ()=> { 
          obs.error(err); 
          obs.complete();  
        });
      }
    } ) ;     

    return this.zsc(objectObservable);
  }

    
  // Get T for ref, Return Promise<T>
  getP<T>(ref : firebase.database.Reference): Promise<T> {
 
    let objectPromise = ref.once('value').then( (snapshot) => {
      return this.runInZone( ()=> { 
        return snapshot.val() as T;
      });
    });

    return this.zsc(objectPromise);
  }
















//   // Build and get a MyFirebaseList
//   static getList(refEles : firebase.database.Reference, refChildren:firebase.database.Reference) {
//     return new MyFirebaseList(refEles, refChildren);
//   }


//   // Build and get a MyFirebaseObject
//   static geObject(refObject : firebase.database.Reference) {
//     return new MyFirebaseObject(refObject);
//   }








//   //
//   // Angular ChangeDetection Observable and Promise
// /*
//   CHD 13 06 2017

//   1)  getO et getP return Observable/Promise executer dans Zone, currentZone
//     ==> faire le getO getP dans la zone, ! pas dans service sans zone...


//   2) faire executer tous les event Firebase dans la zone current ?
//     ==> comment avoir cette zone courante
//     ==> risque de beaucoup d'update

// https://angular.io/docs/ts/latest/api/core/index/NgZone-class.html

// https://blog.thoughtram.io/angular/2016/02/01/zones-in-angular-2.html
// https://github.com/angular/zone.js/

// https://github.com/angular/angularfire2/blob/master/src/database/firebase_object_factory.ts


// */


//   // Update Angular, tick, for Observable, Promise in Angular
//   public static zoneScheduler : (o: any)=>any;

//   // for Observable, Promise in Angular
//   private static zsc( op ) : any {

//     if (MyFirebase.zoneScheduler) 
//       return MyFirebase.zoneScheduler(op);
//     return op;
//   }



// // /**
// //  * TODO: remove this scheduler once Rx has a more robust story for working
// //  * with zones.
// //  */
// // export class ZoneScheduler {
// //   constructor(public zone: Zone) {}

// //   schedule(...args): Subscription {
// //     return <Subscription>this.zone.run(() => queue.schedule.apply(queue, args));
// //   }
// // }


// // Current NgZone
// public static currentZone : NgZone;

// public static runInZone( fct ) {

//   if (!MyFirebase.currentZone) {
//     return fct();
//   }

//   MyFirebase.currentZone.run( ()=> { fct(); } );
  
// }


//   //
//   // Get T for ref , Return Observable<T>
//   static getO<T>(ref : firebase.database.Reference): Observable<T>  {

//     let objectObservable = new Observable<T>( (obs: Observer<T>) => {         
//       try {
//         let fn = ref.on('value', (snapshot) => { 

// MyFirebase.runInZone( ()=> { 
//           let val : T = snapshot.val() as T;          
// console.log("MyFirebase getO NgZone.isInAngularZone:" +  NgZone.isInAngularZone());
//           obs.next(val);

// });          
// //           let val : T = snapshot.val() as T;          
// // console.log("MyFirebase getO NgZone.isInAngularZone:" +  NgZone.isInAngularZone());
// //           obs.next(val);
//         }, (err) => {  

//  // Error
// console.error("getO Error: " + err);

//             obs.error(err);  
//           obs.complete();  
//         });
//         return () => {
//           ref.off('value', fn);
//         }

//       } catch(err) { 

//         obs.error(err); 
//         obs.complete();  
//       }
//     } ) ;     

//     return MyFirebase.zsc(objectObservable);
//   }

    
//   // Get T for ref, Return Promise<T>
//   static getP<T>(ref : firebase.database.Reference): Promise<T> {
 
//     let objectPromise = ref.once('value').then( (snapshot) => {
//       MyFirebase.runInZone( ()=> { 
//         return snapshot.val() as T;
//       });
//     });

//     return MyFirebase.zsc(objectPromise);
//   }



}



// WEBPACK FOOTER //
// ./src/providers/my-firebase.ts